// CustomAlert.js
import { useEffect } from "react";
import Icon from "./components/Icon";

export default function CustomAlert({ message, type = "info", onClose, duration = 10000 }) {
  // Auto-hide after duration
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => onClose(), duration);
    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className={`voice-notice ${type}`} role={type === "error" || type === "warning" ? "alert" : "status"}>
      <p>{message}</p><button type="button" className="voice-icon-button" onClick={onClose} aria-label="Dismiss notification"><Icon name="close" /></button>
    </div>
  );
}
